export const VIEWER_SERIES_DRAG_MIME = "application/x-vxa-series-id"

export function setDraggedSeriesId(dataTransfer: DataTransfer, seriesId: string) {
  dataTransfer.setData(VIEWER_SERIES_DRAG_MIME, seriesId)
  dataTransfer.setData("text/plain", seriesId)
}

export function getDraggedSeriesId(dataTransfer: DataTransfer): string | null {
  const byMime = dataTransfer.getData(VIEWER_SERIES_DRAG_MIME)
  if (byMime) return byMime
  const fallback = dataTransfer.getData("text/plain")
  return fallback || null
}
